<script lang="ts" context="module">
  export type CardRoundness = "s" | "m";
</script>

<script lang="ts">
  export let roundness: CardRoundness = "m";
</script>

<div class:s-roundness={roundness === "s"} class:m-roundness={roundness === "m"}>
  <slot />
</div>

<style>
  div {
    padding: 12px 16px 11px 16px;
    flex: var(--card-flex, 1 1 calc(100% / 3));
    border: 1px solid var(--rk-divider-0);
    background-color: var(--card-bg-color, #fff);
    min-height: var(--card-minH, 80px);
  }

  .s-roundness {
    border-radius: var(--rk-rounding-s);
  }

  .m-roundness {
    border-radius: var(--rk-rounding-m);
  }
</style>
